import IPS = require("publicsector");
import Services = require("../services");

class Service extends Services.BaseService<{ data: IPS.Workorder; href: string }> {

    static about = `Proxy for the workmanagement/workorders service.`;

    constructor(public api: Services.API) {
        super(api, "workmanagement/workorders");
    }

}

export = Service; 